<template>
  <div class="mb-10">
    <header class="flex justify-between">
      <h2 class="text-xl mb-3">{{ kpi.name[lang] }}</h2>
      <div class="actions" v-if="isAdmin">
        <k-dropdown>
          <template slot="handler">
            <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
          </template>
          <k-dropdown-option @click.native="openEdition = true">Edit</k-dropdown-option>
          <k-dropdown-option @click.native="remove">Remove</k-dropdown-option>
        </k-dropdown>
      </div>
    </header>
    <div class="bg-white p-5 shadow rounded">
      <k-tabs>
        <k-tab name="User Previous Week" :selected="true">
          <advice-list :event="kpi.alias" type="upw"></advice-list>
        </k-tab>
        <k-tab name="User All over the Time">
          <advice-list :event="kpi.alias" type="uat"></advice-list>
        </k-tab>
        <k-tab name="Global Current Week">
          <advice-list :event="kpi.alias" type="gcw"></advice-list>
        </k-tab>
        <k-tab name="Global All over the Time">
          <advice-list :event="kpi.alias" type="gat"></advice-list>
        </k-tab>
      </k-tabs>
    </div>
    <kpi-form v-if="openEdition" :id="id" :open="openEdition" @close="close"></kpi-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import adviceList from '@/components/advice/advice-list.vue'
import kpiForm from '@/components/advice/kpi-form.vue'

export default {
  name: 'kpi',

  components: { adviceList, kpiForm },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      openEdition: false
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('kpis', {
      getById: 'getById'
    }),

    ...mapGetters('user', {
      isAdmin: 'isAdmin'
    }),

    kpi () {
      return this.getById(this.id)
    }
  },

  methods: {
    ...mapActions('kpis', ['removeKpi']),

    close () {
      this.openEdition = false
    },
    remove () {
      this.removeKpi({kpi: this.kpi}).then(() => {
        this.$notify({title: 'Success', message: this.$root.$t('notifications.advice.kpiDeleted'), type: 'success'})
      }).catch(() => {
        this.$notify.error({title: 'Success', message: this.$root.$t('notifications.unknown')})
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/advice/kpi.vue